import React, { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const BRTag = ({ div }) => {
  const { hoveredDivision } = useContext(CanvasContext);

  const isHovered = div.id === hoveredDivision;

  const styles = {
    backgroundColor: isHovered ? "lightblue" : div.backgroundColor || "#ffff",
  };

  return (
    <>
      <div style={styles}>
        <br />
      </div>
    </>
  );
};

export default BRTag;
